import {useMutation} from '@tanstack/react-query';
import {getHealthRequestSchedulePermission} from '../../services/getHealthRequestSchedulePermission';

export function useGetHealthRequestSchedulePermissionMutation() {
	return useMutation({
		mutationFn: getHealthRequestSchedulePermission,
	});
}
